import { pick } from '@eastcoal/common/utils/object'

import { StatePlugin } from '@eastcoal/editor/plugins/StatePlugin'

import { useContractDesignerStore } from '../../../designer/Store/hooks/useStore'

export const EditorStatePlugin = () => {
  const {
    formData: { jsonContent }
  } = useContractDesignerStore(state => pick(state, ['formData']))

  return <StatePlugin value={jsonContent} />
}
